import { useEffect, useRef, useState } from "react";
import { ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { ProfileCard } from "@/components/wei/Cards";
import { SectionHeading, Skeleton } from "@/components/wei/Section";

export function FeaturedProfiles({ onSelect, selected }) {
  const [items, setItems] = useState(null);
  const ref = useRef();
  useEffect(() => { api.get("/profiles", { params: { featured: true, limit: 8 } }).then((r) => { setItems(r.data.items); onSelect?.(r.data.items[0]); }).catch(() => setItems([])); }, []); // eslint-disable-line
  return (
    <section data-testid="featured-profiles" className="py-8 min-w-0">
      <SectionHeading title="Featured Profiles" to="/registry?featured=1" id="featured" />
      <div className="relative">
        <div ref={ref} className="flex gap-4 overflow-x-auto no-scrollbar snap-x pb-1">
          {(items || Array(6).fill(null)).map((p, i) => p ? (
            <div key={p.slug} data-testid={`featured-card-${p.slug}`} onMouseEnter={() => onSelect?.(p)} className={`min-w-[160px] sm:min-w-[190px] snap-start ${selected?.slug === p.slug ? "ring-1 ring-gold rounded-md" : ""}`}><ProfileCard p={p} /></div>
          ) : <Skeleton key={i} className="min-w-[190px] h-[230px]" />)}
        </div>
        <button aria-label="Scroll" data-testid="featured-scroll-btn" onClick={() => ref.current?.scrollBy({ left: 400, behavior: "smooth" })} className="hidden md:flex absolute right-1 top-1/2 -translate-y-1/2 w-9 h-9 bg-white border border-[#E6E3DC] rounded-full items-center justify-center hover:border-ink transition-colors"><ChevronRight className="w-4 h-4" /></button>
      </div>
    </section>
  );
}
